// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-material-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springMaterial2EN: PageEntry = {
  id: "post.federwerkstoff",
  locale: "en",
  slug: "spring-material-2",
  seo: {
    title: "Glossary: Spring material explained simply | Dietz GmbH",
    description: "Spring material refers to the material from which a spring is made. Various materials, such as steel, stainless steel, titanium or plastics, can be used for springs. Choosing the r",
  },
  type: "post",
  h1: "Glossary: Spring material explained simply",
  intro: "Spring material refers to the material from which a spring is made. Various materials, such as steel, stainless steel, titanium or plastics, can be used for springs. Choosing the right spring material depends on the specific requirements of the application, including strength, elasticity, corrosion resistance and temperature resistance. A carefully selected spring material is crucial to ensure that the spring can withstand the demands of its environment and maintain its function over a long period of time.",
  blocks: [

  ],
};
